// Photo réelle associée à chaque pack.
//
// Il n'existe que DEUX contenus différents (le reste n'est qu'une quantité) :
//  - flash   : la boîte de jeu seule            -> photo de la boîte
//  - premium : le jeu + les 2 pochons + le questionnaire + l'enveloppe
//              souvenir  -> photo du contenu complet
//  - duo / family : ce sont des packs premium en 2 et 3 exemplaires
//                   -> même photo que premium
//
// On garde `imageUrl` de la base en secours : si un nouveau pack apparaît, il
// continue de s'afficher normalement sans toucher au code.

// flash utilise le visuel vectoriel extrait du fichier d'impression : plus net
// qu'une photo, et sans reflet de pellicule plastique. premium montre la photo
// du contenu réel, car c'est justement ce qu'on achète en plus.
const PACK_PHOTOS = {
  flash: '/photos/boite-face.webp',
  premium: '/photos/contenu.webp',
  // duo et family ne sont plus au catalogue ; on garde la correspondance le
  // temps que les paniers localStorage des visiteurs se vident.
  duo: '/photos/contenu.webp',
  family: '/photos/contenu.webp',
};

const FALLBACK = '/photos/boite-face.webp';

/** Image à afficher pour un pack donné. */
export function packPhoto(pack) {
  if (!pack) return FALLBACK;
  return PACK_PHOTOS[pack.id] || pack.imageUrl || FALLBACK;
}

/** Version 600 px (mobile) quand elle existe, pour le srcSet. */
export function packPhotoSmall(pack) {
  const src = packPhoto(pack);
  return src.startsWith('/photos/') ? src.replace('.webp', '-600.webp') : src;
}
